import { createTheme } from '@material-ui/core/styles';
import ProximaNovaWoff2 from './assets/ProximaNova.woff2';

const proximanova = {
  fontFamily: 'Proxima Nova',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
    local('Proxima Nova'),
    local('Proxima Nova-Regular'),
    url(${ProximaNovaWoff2}) format('woff2')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
const theme = createTheme({
   root: {
    margin: 'auto',
    flexGrow: 1,
    width: '80%',
    marginTop: '2%',
    marginBottom: '5%',
  },
 
  header: {
    fontWeight: 900,
  },
  darkHeader: {
    background: '#1A2226',
    color: '#ffffff',
    padding: '.5em',
    borderRadius: '.15em',
  },
  palette: {
    primary: 
      { 
        main: '#42555E', //gray text for body copy
        light: '#F2F3F4', //gray backgrounds, headers, highlights, selected states
        dark: '#1A2226', //almost black text for headlines,
        contrastText: '#fff',
      },
    secondary: 
      {
        main: '#BE161D', //LS dark red, text links
        light: '#ED1C24', //LS red buttons, headlines, accents
      },
    error: 
      {
        main: '#ED1C24', //LS red text
      },
    warning: 
      {
        main: '#FDC203', //LS yellow accent elements
      },
    info: 
      {
        main: '#065386', //LS blue for text
      },
    success: 
      {
        main: '#379811', //green for text
        light: '#41B314', //light green for form elements
      }
  },
  typography: {
    fontFamily: 'Proxima Nova',
    fontSize: 16,
    htmlFontSize: 16
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [proximanova],
      },
    },
  },
})

export default theme;